import React, { Component } from 'react';
import axios from '../../axios'
import {beforeRouterEach} from '../../common/index'
import TableGroup from '../../base/table/index'
import Title from '../../base/title/index'
import ButtonGroup from '../../base/buttonGroup/index'
import AddModal from './addModal/index'
import ModifyModal from './modifyModal/index'
import './index.css'
import { Divider, message,Modal } from 'antd';
const { confirm } = Modal;

class Index extends Component {
    constructor(props,context){
        super(props,context);
        this.state={
            btnGroup: [
                {
                    type:'add',
                    text:'新增'
                }
            ],
            titleMsg: {
                titleName: '求助管理',
            },
            table: {
                hasHeight: true,
                isPageShow: true,
                current: 1,
                totalCount: 0,
                columns: [
                    {
                        title:'求助名称',
                        dataIndex:'name',
                    },
                    {
                        title: '求助热线',
                        dataIndex: 'phone',
                    },   
                    {
                        title: '操作',
                        key: 'action',
                        render: (text, record) => (
                            <span>
                                <span>
                                   <span className='tableBtn' onClick={(event) => {
                                            this.modify(record)
                                            event.stopPropagation()
                                        }}>编辑</span><Divider type="vertical"/>
                                    <span className='tableBtn' onClick={(event) => {
                                            this.del(record)
                                            event.stopPropagation()
                                        }}>删除</span>
                                    
                                   
                                </span>
                        </span>
                        ),
                    }
                ],
                data: [],
                isSelection: false
            },
            tableParams:{
                rows:10,
                page:1,
            },
            addModalVisible:false,
            modifyModalVisible:false,
           
            detailData:{
                
            },
           
        }
    }
    whickBtnClicked(val){
        if(val==='add'){
            this.setState({
                addModalVisible:true
            })
        }
    } 
    modify(record){
        axios.gets('/api/v1/seek/help/detail',{id:record.id})
            .then((res)=>{
                if(res.status===200){
                    this.setState({
                        detailData:res.data
                    },()=>{
                        this.setState({
                            modifyModalVisible:true
                        })
                    })
                }else{
                    message.error(res.message)
                }
            })
        
    }
    del(record){
        let _this=this;
        confirm({
            title: '是否删除当前求助信息?',
            content: '',
            onOk() {
              axios.posts('/api/v1/seek/help/remove',{id:record.id})
                .then((res)=>{
                    if(res.status===200){
                        message.success('删除成功！')
                        _this.getDataList()
                    }else{
                        message.error(res.message)
                    }
                })
            },
            onCancel() {
              console.log('Cancel');
            },
        });
    }
    getDataList(){
        axios.gets('/api/v1/seek/help/find',this.state.tableParams)
            .then((res)=>{
                if(res.status===200){
                    let data = Object.assign({}, this.state.table, {
                        data: res.data.records,
                        totalCount: res.data.total,
                    });
                    this.setState({
                        table: data
                    })
                }else{
                    message.error(res.message)
                }
            })  
    }
   
    selectedChange(val){
        console.log(val)
    }
    tableSizeChange(current, pageSize) {
        let data = Object.assign({}, this.state.table, {
            current: current,
        });
        this.setState({
            table: data
        });
        let data2 = Object.assign({}, this.state.tableParams, {
            rows: pageSize,
        });
        this.setState({
            tableParams: data2
        }, () => {
            this.getDataList();
        });

    }
    tablePageChange(page) {
        let data = Object.assign({}, this.state.table, {
            current: page,
        });
        this.setState({
            table: data
        });
        let data2 = Object.assign({}, this.state.tableParams, {
            page: page ,
        });
        this.setState({
            tableParams: data2
        }, () => {
            this.getDataList();
        });
    }
   
    componentDidMount(){
        beforeRouterEach(this)
        this.getDataList();
    }
    changeAddModal(val,values){
        this.setState({
            addModalVisible:val
        })
        if(values!==''){
            axios.posts('/api/v1/seek/help/insert',values)
                .then((res)=>{
                    if(res.status===200){
                        message.success('新增成功！')
                        this.getDataList();
                    }else{
                        message.error(res.message)
                    }
                })
        }
    }
    changeModifyModal(val,values){
        this.setState({
            modifyModalVisible:val
        })
        if(values!==''){
            let data={
                id:this.state.detailData.id,
                name:values.name,
                phone:values.phone
            }
            axios.posts('/api/v1/seek/help/modify',data)
                .then((res)=>{
                    if(res.status===200){
                        message.success('修改成功！')
                        this.getDataList();
                    }else{
                        message.error(res.message)
                    }
                })
        }
    }
   

    render() {
        return (
            <div className="helpManage">
                <Title titleMsg={this.state.titleMsg}/> 
               <ButtonGroup
                    whichClick={this.whickBtnClicked.bind(this)}
                    btnGroup={this.state.btnGroup}
               />
               <TableGroup
                    selectedChange={this.selectedChange.bind(this)}
                    pageChange={this.tablePageChange.bind(this)}
                    sizeChange={this.tableSizeChange.bind(this)}
                    table={this.state.table}/>
                <AddModal
                    changeVisible={this.changeAddModal.bind(this)}
                    visible={this.state.addModalVisible}
                />
                <ModifyModal
                    detailData={this.state.detailData}
                    changeVisible={this.changeModifyModal.bind(this)}
                    visible={this.state.modifyModalVisible}
                /> 
               
            </div>
        );
    }
}

export default Index;